import styled from 'styled-components'
import {
  textStyleSizeOptions,
  textStyleWeightOptions,
  textStyleSizeStyleOptions,
  textStyleWeightStyleOptions
} from '../../fundamentals/text-styles/constants'
import colorsOptions from '../../fundamentals/colors-styles/constants'
import { motion } from 'framer-motion'

export const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0.5rem;
  position: relative;
`

export const SearchInput = styled(motion.input)`
  width: 100%;
  flex: 1;
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-L']]};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
  color: ${colorsOptions.greys['grey-100']};
  background: ${colorsOptions.greys['grey-20']};
  caret-color: ${colorsOptions.docuToolsOrange.orange};
  &::placeholder {
    color: ${colorsOptions.greys['grey-70']};
  }
  &:focus {
    &::placeholder {
      color: ${colorsOptions.greys['grey-30']};
    }
  }

  &:disabled {
    &::placeholder {
      opacity: 0;
    }
  }

  &[data-is-open='false'] {
    width: 0;
    flex: none;
  }
`

export const SearchContainerMobile = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0.5rem 1rem;
  gap: 0.5rem;
  width: 100%;
  border-radius: 160px;
  border: 0.5px solid ${colorsOptions.greys['grey-30']};
  background: ${colorsOptions.greys['grey-20']};
  transition: width 0.8s ease;
`

export const SearchContainerDesktop = styled(SearchContainerMobile)`
  background: transparent;
  border: none;
  padding: 0.5rem;

  ${SearchInput} {
    background: transparent;
    &::placeholder {
      opacity: 0;
    }
    &:focus {
      &::placeholder {
        opacity: 1;
      }
    }
  }

  &[data-is-open='false'] {
    gap: 0;
  }
`

export const SearchContainerGlobal = styled(SearchContainerMobile)`
  border-color: ${colorsOptions.greys['grey-70']};
  background: ${colorsOptions.greys['grey-90']};
  height: 32px;
  padding: 0.5rem 1rem;
  gap: 4px;

  ${SearchInput} {
    &::placeholder {
      color: ${colorsOptions.greys['grey-50']};
    }

    ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-S']]};
    ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
    background: ${colorsOptions.greys['grey-90']};
    color: ${colorsOptions.greys.white};
    font-style: normal;
    font-weight: 600;
    line-height: 1;
    letter-spacing: 0.2px;
  }
`
